import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dropdown position-static" }
const _hoisted_2 = {
  class: "dropdown-menu",
  "aria-labelledby": "dropdownAcoesButton"
}
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("button", {
      class: "btn btn-sm btn-primary dropdown-toggle",
      type: "button",
      id: "dropdownAcoesButton",
      "data-bs-toggle": "dropdown",
      "aria-expanded": "false"
    }, " Ações ", -1 /* CACHED */)),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.acoes, (acao, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: acao.label + index
        }, [
          (acao.nomeRota)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "dropdown-item",
                to: {
            name: acao.nomeRota,
            params: { id: _ctx.id },
          }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(acao.label), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]))
            : (acao.acao)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: ($event: any) => (acao.acao(_ctx.item)),
                  class: "dropdown-item"
                }, _toDisplayString(acao.label), 9 /* TEXT, PROPS */, _hoisted_3))
              : _createCommentVNode("v-if", true)
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}